<app-top>
  <h1>Resultat</h1>
  <h2>Så här mycket skulle du kunna tjäna</h2>
</app-top>

<div class="details">
  <div class="details-wrapper">
    <span class="details-item"><strong>Antal kor:</strong> {{ cows | number }} st </span>
    <span class="details-item"><strong>Mjölkproduktion:</strong> {{ production | number }} kg/år </span>
    <span class="details-item"><strong>Celltal:</strong> {{ cells }} tusen </span>
    <span class="details-item"><strong>Mjölkpris:</strong> {{ price | number : '.2' }} kr/kg </span>
  </div>
</div>

<div class="box result">
  <div class="result-item">
    <h3 class="result-title">{{ result.milk | number }} kg/år</h3>
    <p class="result-text">Kilo mjölk du skulle fått om du istället hade haft 150 tusen i celltal</p>
  </div>
  <div class="result-item">
    <h3 class="result-title">{{ result.profit | number }} kr/år</h3>
    <p class="result-text">Pengar du skulle ha tjänat om du i stället hade haft 150 tusen i celltal</p>
  </div>
  <div class="result-item">
    <h3 class="result-title emergency">{{ result.loosing | number : '1.0-0' }} öre/kg mjölk</h3>
    <p class="result-text">Pengar du idag förlorar per kilo mjölk för utebliven produktion</p>
  </div>
</div>

<div class="footer">
  <a appButton variant="link" class="primary-btn" routerLink="/juverhalsa" [queryParams]="editLinkQueryParams">Tillbaka</a>
</div>
